import { lazy } from 'react';

import type { Policy } from '@cartwhl/common/appletPolicy';

import type { AppletDefinition } from '../../applets';
import StudioShellLayout from '../StudioShellLayout';

const LazyBatchGeneration = lazy(() => import('./components/BatchGeneration'));

const applet = {
  id: 'generation',
  path: '/generation',
  paths: [
    '/generation',
    '/generation/:id',
    '/swing',
    '/swing/:id',
    '/batch-generation',
    '/batch-generation/:id',
    '/batch-swing',
    '/batch-swing/:id',
  ],
  label: 'Performance Generation',
  description: 'Text-to-motion generation',
  dashboard: {
    imageSrc:
      'https://resources.getcartwheel.com/share/demo-videos/swing_square_first_frame.jpg',
    imageAlt: '',
    videoSrc:
      'https://resources.getcartwheel.com/share/demo-videos/swing_square_output.webm',
    title: 'Performance Generation',
    description: 'Text-to-motion. Generate any number of motions from prompts.',
    order: 20,
  },
  policy: {
    requiresLoggedIn: true,
    requiresApiKey: 'soft',
  } satisfies Policy,
  component: LazyBatchGeneration,
  layout: StudioShellLayout,
} satisfies AppletDefinition;

export default applet;
